import { render, staticRenderFns } from "./SharedWorkspace.vue?vue&type=template&id=4b9d5144"
import script from "./SharedWorkspace.vue?vue&type=script&lang=js"
export * from "./SharedWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports